<template>
  <div id="app" class="app">
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> 
  </div>
</template>
<script>
import headervue from "@/components/header/header.vue";
import AES from "./utils/AES";
import Api from "./api/api";
export default {
  name: "WanKangModel",
  data() {
    return {
      suffix: "FJsdAg",
      isHome: 1, // 1.首页 2.模型网页版
    };
  },
  created() {
    this.init();
    this.getCode();
  },
  computed: {
    isKeepAlive() {
      return this.$route.meta.keepAlive;
    }
  },
  components: {},
  mounted() { },
  methods: {
    getCode() {
      // 获取当前 URL
      const currentURL = window.location.href;
      // 提取查询字符串部分
      const queryString = currentURL.split("?")[1];
      // 解析 URL 的查询字符串
      const urlParams = new URLSearchParams(queryString);
      const paramValue = urlParams.get("bd_vid");
      // console.log("拿到的参数", paramValue);
      if (paramValue) {
        sessionStorage.setItem("bd_vid", AES.endata(paramValue));
      }
      let data = {
        // url:"http://wk.njtp88.top/#/?bd_id=54753734&bd_cl=240424_pa&bd_vid=uANBIyIxUhNLgvw-I-tznHn3P1cvg1cvg1DLnHn4n16kn10dnjb"
        url: currentURL,
      };
      // console.log("发送的数据", data);
      Api.initBpage(data).then((res) => {
        // console.log("广告数据-------------", res, Math.floor(Date.now() / 1000));
      });
    },
    timestampToDate(timestamp) {
      const date = new Date(timestamp);

      // 获取年份
      const year = date.getFullYear();

      // 获取月份（注意月份是从0开始的，所以要加1）
      const month = String(date.getMonth() + 1).padStart(2, "0");

      // 获取日期
      const day = String(date.getDate()).padStart(2, "0");

      // 获取小时
      const hours = String(date.getHours()).padStart(2, "0");

      // 获取分钟
      const minutes = String(date.getMinutes()).padStart(2, "0");

      // 获取秒
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // 获取毫秒
      const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

      // 拼接成所需格式的字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    },
    init() {
      this.$td.setSuperProperties({ channel_name: "web" }); // 静态公共属性
      // 动态公共属性
      let vip = null;
      if (localStorage.getItem("token")) {
        Api.getUserInfo().then((res) => {
          if (res.code == 200) {
            vip = res.data.vip_type;
          }
        });
      }
      this.$td.setDynamicSuperProperties(function () {
        return { vip_state: vip != 0 };
      });
      this.$td.userSetOnce({ channel_name: "web" });
      this.$td.userSetOnce({ activate_time: this.timestampToDate(Date.now()) });
      this.$td.userSet({ activity_time: this.timestampToDate(Date.now()) });
      let a = this.$store.state.keysOne;
      let b = this.$store.state.keysEnd;
      let c = this.suffix;
      this.$store.state.secretKey = a + b + c;
    },
    changeView(z) {
      this.isHome = z;
    },
    // 前往个人中心
    goPersonal(z) {
      this.isHome = z;
    },
  },
  destroyed() { },
};
</script>

<style lang="scss">
#app {
  height: 100%;
}

.cascader {
  .el-cascader-panel {
    .el-radio {
      width: 100%;
      height: 100%;
      z-index: 10;
      position: absolute;
      top: 10px;
      right: -10px;
    }

    .el-radio__input {
      visibility: hidden; //隐藏单选框，不隐藏就不用设置
    }

    .el-cascader-node__postfix {
      top: 10px;
    }
  }
}

// 取消输入框选中时出现的边框
input {
  outline: none !important;
}

* {
  user-select: none;
  margin: 0;
  padding: 0;
}

// 禁止图片拖动
img {
  -webkit-user-drag: none;
}

// 禁止链接拖动
a {
  -webkit-user-drag: none;
}
</style>
